module.exports = __webpack_public_path__ + "assets/student.f9870d239483061bf1889b46ddf8b33b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/services/student.jpg
// module id = 314
// module chunks = 0